import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addMenuSon from "./menuManger/addMenuSon.vue";
import addPageCom from './menuManger/addPage';
import interFaceConfigCom from './menuManger/interFaceConfig'; // import {errorCode} from '@/config/errorCode'

import { getmenulist, addmenu, menu_del, menu_update, api_config_update } from '@/api/auth';
import { recursiveMenu } from '@/libs/util';
export default {
  name: "menuManger",
  data: function data() {
    return {
      spinShow: false,
      buttonProps: {
        type: 'text',
        size: 'small'
      },
      tobButtonList: [{
        name: '新增子菜单',
        icon: 'ios-add',
        type: 'primary',
        method: this.addMenu
      }, {
        name: '新增页面',
        icon: 'ios-add-circle',
        type: 'primary',
        method: this.addPage
      }, {
        name: '刷新',
        icon: 'ios-refresh',
        type: 'primary',
        method: this.init
      }],
      data: [],
      moduleShow: false,
      addType: true,
      addData: {
        module_name: "",
        res_name: "",
        res_desc: ""
      },
      addDataValidate: {
        module_name: [{
          required: true,
          message: '请查看父级模块',
          trigger: 'blur'
        }],
        res_name: [{
          required: true,
          message: '模块名必填',
          trigger: 'blur'
        }],
        res_desc: [{
          required: true,
          message: '模块说明必填',
          trigger: 'blur'
        }]
      }
    };
  },
  props: {},
  components: {},
  computed: {
    getWinH: function getWinH() {
      var height = this.$store.state.wh.innerHeight - 55;
      return height;
    }
  },
  methods: {
    init: function init() {
      var _this2 = this;

      var vm = this;
      this.spinShow = true;
      getmenulist().then(function (res) {
        _this2.spinShow = false;

        if (res.result === 0) {
          var arr = recursiveMenu(res.body || []);
          vm.$set(vm, 'data', arr);
        } else {
          vm.$set(vm, 'data', []);
        }
      });
    },
    renderContent: function renderContent(h, _ref) {
      var _this3 = this;

      var root = _ref.root,
          node = _ref.node,
          data = _ref.data;

      //首先判断一下，是页面 还是子菜单
      if (data.category === 0) {
        var baseBtn = [h('Button', {
          props: Object.assign({}, this.buttonProps, {}),
          style: {
            marginLeft: "3px",
            color: '#2d8cf0'
          },
          on: {
            click: function click() {
              _this3.editMenu(root, node, data);
            }
          }
        }, "编辑"), h('Button', {
          props: Object.assign({}, this.buttonProps, {
            type: 'text'
          }),
          style: {
            marginLeft: "3px",
            color: '#2d8cf0'
          },
          on: {
            click: function click() {
              _this3.delMenu(data);
            }
          }
        }, "删除")]; //子菜单

        baseBtn.unshift(h('Button', {
          props: Object.assign({}, this.buttonProps, {}),
          style: {
            marginLeft: "3px",
            color: '#2d8cf0'
          },
          on: {
            click: function click() {
              _this3.addMenu(root, node, data);
            }
          }
        }, "新增子菜单"), h('Button', {
          props: Object.assign({}, this.buttonProps, {}),
          style: {
            marginLeft: "3px",
            color: '#2d8cf0'
          },
          on: {
            click: function click() {
              _this3.addPage(root, node, data);
            }
          }
        }, "新增页面"));
        return h('span', {
          'class': {
            'ivu-tree-title': true
          },
          style: {
            display: 'inline-block',
            width: '100%'
          }
        }, [h('span', [h('Icon', {
          props: {
            type: 'ios-paper-outline'
          },
          style: {
            marginRight: '8px'
          }
        }), h('span', data.title)]), h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
            marginRight: '32px'
          }
        }, baseBtn)]);
      } else if (data.category === 1) {
        var _baseBtn = [h('Button', {
          props: Object.assign({}, this.buttonProps, {}),
          style: {
            marginLeft: "3px",
            color: '#2d8cf0'
          },
          on: {
            click: function click() {
              _this3.editPage(root, node, data);
            }
          }
        }, "编辑"), h('Button', {
          props: Object.assign({}, this.buttonProps, {
            type: 'text'
          }),
          style: {
            marginLeft: "3px",
            color: '#2d8cf0'
          },
          on: {
            click: function click() {
              _this3.delPage(data);
            }
          }
        }, "删除")]; //页面
        //子菜单

        _baseBtn.unshift(h('Button', {
          props: Object.assign({}, this.buttonProps, {}),
          style: {
            marginLeft: "3px",
            color: '#2d8cf0'
          },
          on: {
            click: function click() {
              _this3.interfaceConfig(root, node, data);
            }
          }
        }, "接口配置"));

        return h('span', {
          'class': {
            'ivu-tree-title': true
          },
          style: {
            display: 'inline-block',
            width: '100%'
          }
        }, [h('span', [h('Icon', {
          props: {
            type: 'ios-paper-outline'
          },
          style: {
            marginRight: '8px'
          }
        }), h('span', data.title)]), h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
            marginRight: '32px'
          }
        }, _baseBtn)]);
      }
    },
    //新增子菜单
    addMenu: function addMenu(root, node, data) {
      var personMenu; //判断是否是顶级菜单

      if (node != undefined) {
        if (node.nodeKey !== 0) {
          var pnode = node.node;
          personMenu = {
            parent_code: pnode.code,
            personName: pnode.menu_name
          };
        } else {
          personMenu = {
            parent_code: data.code,
            personName: data.menu_name
          };
        }
      }

      var vm = this;
      var config = {
        loading: true,
        width: 600,
        okText: '确定',
        cancelText: '取消',
        render: function render(h) {
          return h('div', [h('h3', "新增子菜单"), h(addMenuSon, {
            ref: 'addMenuSon',
            props: {
              edit: false,
              _vm: vm,
              personMenu: personMenu
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addMenuSon;
          obj.formCheck().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              addmenu(_objectSpread({}, formModel, {
                category: 0
              })).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(vm.$t('添加成功！'));
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(errorCode[res.result]);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    //编辑菜单
    editMenu: function editMenu(root, node, data) {
      var personMenu; //判断是否是顶级菜单

      if (node.nodeKey !== 0 && node.node.parent_id !== 0) {
        for (var i = 0; i < root.length; i++) {
          var listnode = root[i];

          if (listnode.node.hasOwnProperty('id')) {
            if (listnode.node.id == node.node.parent_id) {
              var pnode = listnode.node;
              personMenu = {
                parent_code: pnode.code,
                personName: pnode.menu_name
              };
              break;
            }
          }
        }
      }

      var vm = this;
      var config = {
        loading: true,
        width: 600,
        okText: '确定',
        cancelText: '取消',
        render: function render(h) {
          return h('div', [h('h3', "编辑菜单"), h(addMenuSon, {
            ref: 'addMenuSon',
            props: {
              edit: true,
              _vm: vm,
              setData: data,
              personMenu: personMenu
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addMenuSon;
          obj.formCheck().then(function (res) {
            if (res) {
              //提交请求
              var _obj$formModel = obj.formModel,
                  id = _obj$formModel.id,
                  parent_code = _obj$formModel.parent_code,
                  menu_name = _obj$formModel.menu_name,
                  api_ids = _obj$formModel.api_ids,
                  route = _obj$formModel.route,
                  menu_desc = _obj$formModel.menu_desc,
                  sort_order = _obj$formModel.sort_order;
              menu_update({
                menu_id: id,
                parent_code: parent_code,
                menu_name: menu_name,
                api_ids: api_ids,
                route: route,
                menu_desc: menu_desc,
                sort_order: sort_order,
                category: 0
              }).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(vm.$t('编辑成功！'));
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    //删除菜单
    delMenu: function delMenu(data) {
      var _this4 = this;

      var vm = this;
      var config = {
        title: "删除菜单",
        loading: true,
        content: "<p>\u786E\u5B9A\u662F\u5426\u5220\u9664\u8BE5\u83DC\u5355\uFF1F</p>",
        onOk: function onOk() {
          var _this = _this4;

          var params = {
            menu_id: data.id
          },
              callback = function callback(res) {
            if (res.result === 0) {
              vm.$Modal.remove();
              vm.init();
              vm.$Message.success(res.errorMsg);
            } else {
              _this.buttonLoading = false;
              vm.$Message.error("\u5220\u9664".concat(res.errorMsg));
            }
          };

          menu_del(params).then(function (res) {
            callback(res);
          });
        }
      };
      this.$Modal.confirm(config);
    },
    //添加子页面
    addPage: function addPage(root, node, data) {
      var personMenu; //判断是否是顶级菜单

      if (node != undefined) {
        if (node.nodeKey !== 0) {
          var pnode = node.node;
          personMenu = {
            parent_code: pnode.code,
            personName: pnode.menu_name
          };
        } else {
          personMenu = {
            parent_code: data.code,
            personName: data.menu_name
          };
        }
      }

      var vm = this;
      var config = {
        loading: true,
        width: 1000,
        okText: '确定',
        cancelText: '取消',
        render: function render(h) {
          return h('div', [h('h3', "新增页面"), h(addPageCom, {
            ref: 'addPageCom',
            props: {
              edit: false,
              _vm: vm,
              personMenu: personMenu
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addPageCom;
          obj.formCheck().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              addmenu(_objectSpread({}, formModel, {
                category: 1
              })).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(vm.$t('添加成功！'));
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(errorCode[res.result]);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    //编辑页面
    editPage: function editPage(root, node, data) {
      var personMenu; //判断是否是顶级菜单

      if (node.nodeKey !== 0 && node.node.parent_id !== 0) {
        for (var i = 0; i < root.length; i++) {
          var listnode = root[i];

          if (listnode.node.hasOwnProperty('id')) {
            if (listnode.node.id == node.node.parent_id) {
              var pnode = listnode.node;
              personMenu = {
                parent_code: pnode.code,
                personName: pnode.menu_name
              };
              break;
            }
          }
        }
      }

      var vm = this;
      var config = {
        loading: true,
        width: 1000,
        okText: '确定',
        cancelText: '取消',
        render: function render(h) {
          return h('div', [h('h3', "修改页面"), h(addPageCom, {
            ref: 'addPageCom',
            props: {
              edit: true,
              _vm: vm,
              personMenu: personMenu,
              setData: data
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addPageCom;
          obj.formCheck().then(function (res) {
            if (res) {
              //提交请求
              var _obj$formModel2 = obj.formModel,
                  id = _obj$formModel2.id,
                  parent_code = _obj$formModel2.parent_code,
                  menu_name = _obj$formModel2.menu_name,
                  api_codes = _obj$formModel2.api_codes,
                  route = _obj$formModel2.route,
                  menu_desc = _obj$formModel2.menu_desc,
                  sort_order = _obj$formModel2.sort_order;
              menu_update({
                menu_id: id,
                parent_code: parent_code,
                menu_name: menu_name,
                api_codes: api_codes,
                route: route,
                menu_desc: menu_desc,
                sort_order: sort_order,
                category: 1
              }).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(vm.$t('修改成功！'));
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(errorCode[res.result]);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    //删除页面
    delPage: function delPage(data) {
      var _this5 = this;

      var vm = this;
      var config = {
        title: "删除页面",
        loading: true,
        content: "<p>\u786E\u5B9A\u662F\u5426\u5220\u9664\u8BE5\u9875\u9762\uFF1F</p>",
        onOk: function onOk() {
          var _this = _this5;

          var params = {
            menu_id: data.id
          },
              callback = function callback(res) {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              vm.$Modal.remove();
              vm.init();
            } else {
              _this.buttonLoading = false;
              vm.$Message.error("\u5220\u9664".concat(res.errorMsg));
            }
          };

          menu_del(params).then(function (res) {
            callback(res);
          });
        }
      };
      this.$Modal.confirm(config);
    },
    //接口配置
    interfaceConfig: function interfaceConfig(root, node, data) {
      var vm = this;
      var config = {
        loading: true,
        width: 1000,
        okText: '确定',
        cancelText: '取消',
        render: function render(h) {
          return h('div', [h('h3', "修改接口配置"), h(interFaceConfigCom, {
            ref: 'interFaceConfigCom',
            props: {
              edit: true,
              _vm: vm,
              setData: data
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.interFaceConfigCom;
          obj.formCheck().then(function (res) {
            if (res) {
              //提交请求
              var _obj$formModel3 = obj.formModel,
                  id = _obj$formModel3.id,
                  api_codes = _obj$formModel3.api_codes;
              api_config_update({
                api_codes: api_codes,
                menu_id: id
              }).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(vm.$t('修改成功！'));
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(errorCode[res.result]);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    }
  },
  mounted: function mounted() {
    this.init();
  }
};